import React, { useCallback, useState } from "react";
import { List } from "react-window";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { getImage } from "../utils/images";

export function getAssetLabel(asset) {
  return `${asset.description || ""} ${asset.model || ""}`.trim();
}

function getLabel(asset) {
  return [asset.itemId, asset.description, asset.model]
    .filter(v => v)
    .join(" | ")
    .trim();
}

export default function SearchAutocomplete({ value, collection, onChange, selectAsset, size }) {
  const [showSuggestions, setShowSuggestions] = useState(false);

  const closeSuggestions = () => setShowSuggestions(false);

  const handleChange = useCallback(
    event => {
      setShowSuggestions(true);
      onChange(event.target.value);
    },
    [onChange, setShowSuggestions]
  );

  const Row = useCallback(
    ({ index, style }) => {
      const asset = collection[index];
      return (
        <div style={style}>
          <Box mt={1}>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => {
                selectAsset(asset);
                onChange(getLabel(asset));
                closeSuggestions();
              }}
            >
              <Box
                display="flex"
                height="30px"
                width="100%"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box maxWidth="50%" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                  {getLabel(asset)}
                </Box>
                <Box data-id="asset-images">
                  {asset.images.map((image, index) => (
                    <Box mr={0.5} key={index} borderRadius={4} clone>
                      <img style={{ maxHeight: "30px" }} src={getImage(image.url)} alt="" />
                    </Box>
                  ))}
                </Box>
              </Box>
            </Button>
          </Box>
        </div>
      );
    },
    [collection]
  );

  return (
    <ClickAwayListener onClickAway={closeSuggestions}>
      <Box>
        <TextField
          fullWidth
          size={size}
          variant="outlined"
          label="Search Assets"
          value={value}
          onFocus={() => setShowSuggestions(true)}
          onChange={handleChange}
        />
        {showSuggestions && (
          <Box position="relative">
            <Box
              position="absolute"
              width="100%"
              height={250}
              bgcolor="white"
              border="1px solid #ddd"
              zIndex={10}
              overflow="auto"
            >
              <List style={{ height: 250, width: "100%" }} rowCount={collection.length} rowHeight={46} rowComponent={Row} rowProps={{}} />
            </Box>
          </Box>
        )}
      </Box>
    </ClickAwayListener>
  );
}
